import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Typography, Box } from '@mui/material';
import { Home, NavigateNext } from '@mui/icons-material';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const routeLabels: Record<string, string> = {
  '/app/dashboard': 'Dashboard',
  '/app/incidents': 'Events',
  '/app/lhd-forms': 'LHD Form',
  '/app/users': 'Users',
  '/app/categories': 'Categories',
  '/app/units': 'Units',
  '/app/reports': 'Reports',
  '/app/monitor': 'Monitor',
  '/app/avisky-sync': 'Avi Sky Sync',
  '/app/configuration': 'Configuration',
  '/app/settings': 'Settings',
};

export const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Home', path: '/app/dashboard' },
  ];

  // Build breadcrumb items from path
  let currentPath = '';
  pathnames.forEach((name, index) => {
    currentPath += `/${name}`;
    const label = routeLabels[currentPath] || name.charAt(0).toUpperCase() + name.slice(1);
    if (index < pathnames.length - 1) {
      breadcrumbs.push({ label, path: currentPath });
    } else {
      breadcrumbs.push({ label, path: currentPath });
    }
  });

  return (
    <Box sx={{ px: 3, py: 1.5, bgcolor: 'rgba(255,255,255,0.02)' }} aria-hidden="true">
      <MuiBreadcrumbs
        separator={<NavigateNext fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          '& .MuiBreadcrumbs-ol': {
            flexWrap: 'nowrap',
          },
          '& .MuiBreadcrumbs-li': {
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return isLast ? (
            <Typography key={crumb.path} color="text.primary" variant="body2">
              {crumb.label}
            </Typography>
          ) : (
            <Link
              key={crumb.path}
              to={crumb.path}
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 4,
              }}
            >
              {index === 0 && <Home fontSize="small" />}
              <Typography variant="body2" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                {crumb.label}
              </Typography>
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};
